/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import t from "react";
const o = t.createContext([null, (e) => {
}]), s = t.createContext([null, (e) => {
}]), a = t.createContext([null, (e) => {
}]);
export {
  a as ChipListDataContext,
  s as ChipListFocusContext,
  o as ChipListSelectionContext
};
